import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/lib/toast"
import { CompanyEditFormData } from "@/schemas/admin/companySchema";

interface UpdateCompanyParams {
  id: number;
  data: CompanyEditFormData;
}

export const useUpdateCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: UpdateCompanyParams) => {
      console.log("Atualizando empresa:", id, data);

      const { data: empresa, error } = await supabase
        .from('empresas')
        .update({
          razao_social: data.razao_social,
          nome_fantasia: data.nome_fantasia,
          cnpj: data.cnpj,
          area_atuacao: data.area_atuacao,
          ativo: data.ativo,
          rua: data.rua,
          cidade: data.cidade,
          uf: data.uf,
          cep: data.cep,
        })
        .eq('id', id)
        .select()
        .single();

      if (error) {
        console.error("Erro ao atualizar empresa:", error);
        throw new Error(error.message);
      }

      console.log("Empresa atualizada:", empresa);
      return empresa;
    },
    onSuccess: () => {
      toast.success("Empresa atualizada com sucesso!");
      queryClient.invalidateQueries({ queryKey: ["admin-companies"] });
    },
    onError: (error: Error) => {
      console.error("Erro ao atualizar empresa:", error);
      toast.error(`Erro ao atualizar empresa: ${error.message}`);
    },
  });
};
